import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const voyageRecordsApi = AiseaApiFactory.get("voyageRecords");

class VoyageService {
  /**
   * 航跡取得
   * @param {*} vesselId
   * @returns
   */
  async fetchWakeByVesselId(vesselId) {
    const res = await voyageRecordsApi.fetchWakeByVesselId(vesselId);
    return res;
  }
  /**
   * lastPosition取得
   * @param {*} vesselId
   * @returns
   */
  async getLastPosition(vesselId) {
    const res = await voyageRecordsApi.getLastPosition(vesselId);
    return res;
  }
  /**
   * タイムアウト付きでlastPosition取得
   * [TODO] 最終的にgetLastPositionと統合したい
   * @param {*} vesselId
   * @returns
   */
  async getLastPositionWithTimeout(vesselId) {
    const res = await voyageRecordsApi.getLastPositionWithTimeout(vesselId);
    return res;
  }
}

export default new VoyageService();
